export class ErrorMessage {
  message: string;
  isValid: boolean;

  constructor(message: string, isValid: boolean) {
    this.message = message;
    this.isValid = isValid;
  }
}
